export default "__VITE_ASSET__CDXd49df__"